import { useFeatureFlags } from './useFeatureFlags';

/**
 * PostHog flag gating the Behavior Tracking pilot. Pilot clinics are targeted by a
 * `clinicId` cohort in the PostHog dashboard, so the pilot roster changes without a deploy.
 */
export const BEHAVIOR_TRACKING_ENABLED = 'behavior_tracking_enabled';

/**
 * Whether the Behavior Tracking pilot is enabled for the current user/clinic.
 *
 * Resolves to `false` until flags load and wherever PostHog is inert (Canada/Australia, and dev-US)
 * — the pilot is opt-in, so an unknown state must hide the feature rather than expose it.
 *
 * @returns {{ flagsReady: <boolean>, behaviorTrackingEnabled: <boolean> }}
 */
// eslint-disable-next-line import/prefer-default-export
export function useBehaviorTrackingFeature() {
  const { flagsReady, useFeatureEnabled } = useFeatureFlags();

  const behaviorTrackingEnabled = useFeatureEnabled(BEHAVIOR_TRACKING_ENABLED);

  return {
    flagsReady,
    behaviorTrackingEnabled,
  };
}
